import styled from "styled-components";
import { css } from "styled-components";

const disabledCss = css`
  opacity: 0.5;
  cursor: not-allowed;
`;
const Button = styled.button`
  font-family: "Montserrat", sans-serif;
  border-radius: 5px;
  box-sizing: border-box;
  cursor: pointer;
  border: 0;
  font-size: 16px;
  font-weight: 500;
  padding: 10px 18px;
  transition: all 150ms linear;
  color: #ffffff;
  background-color: #eb5e28;
  border-color: #eb5e28;
  opacity: 1;
  line-height: 1.4;
  white-space: nowrap;
  ${props => props.disabled && disabledCss};
`;

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.js